import { render, staticRenderFns } from "./custom-select-color-dropdown-content.vue?vue&type=template&id=23a6c5aa&"
import script from "./custom-select-color-dropdown-content.vue?vue&type=script&lang=js&"
export * from "./custom-select-color-dropdown-content.vue?vue&type=script&lang=js&"
import style0 from "./custom-select-color-dropdown-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a6c5aa')) {
      api.createRecord('23a6c5aa', component.options)
    } else {
      api.reload('23a6c5aa', component.options)
    }
    module.hot.accept("./custom-select-color-dropdown-content.vue?vue&type=template&id=23a6c5aa&", function () {
      api.rerender('23a6c5aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/custom-select/custom-select-color-dropdown-content.vue"
export default component.exports